export const CITRA_DATA_ACTIONS = {
  UPDATE_PASS_VALUE_SUCCESS: 'UPDATE_PASS_VALUE_SUCCESS',
  UPDATE_PASS_VALUE_FAILED: 'UPDATE_PASS_VALUE_FAILED'
};
